var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCryptoGeneralIconsClose = function SvgCryptoGeneralIconsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.2 13.2",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 1.3 11.9 0 6.6 5.3 1.3 0 0 1.3l5.3 5.3L0 11.9l1.3 1.3 5.3-5.3 5.3 5.3 1.3-1.3-5.3-5.3 5.3-5.3z"
  })));
};
export { SvgCryptoGeneralIconsClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMy4yIDEzLjIiPjxwYXRoIGQ9Ik0xMy4yIDEuMyAxMS45IDAgNi42IDUuMyAxLjMgMCAwIDEuM2w1LjMgNS4zTDAgMTEuOWwxLjMgMS4zIDUuMy01LjMgNS4zIDUuMyAxLjMtMS4zLTUuMy01LjMgNS4zLTUuM3oiLz48L3N2Zz4=";